import React from 'react'

const Loader = () => {
    return (
        <>
            <div className="loader_wrapper">
                <img width="200px" src="/malikane-electronics-logo-tek.png" alt="loader" />
            </div>
        </>
    )
}

export default Loader